import './index.scss'
import success from "@assets/image/rzIndex/success.png";
import fail from "@assets/image/rzIndex/fail.png";
import { useEffect, useState } from 'react';
import { DotLoading, ErrorBlock, Tabs, Toast } from 'antd-mobile';
import { applySign, getUserInfo, startH5Face } from '@src/service/applyFormSubService';
import { getQueryParams } from '@src/util';
import CustomScroll from '@src/component/customScroll';

const Success = () => {
  useEffect(() => {
    document.title = "签署成功"
  }, [])
  return <div className='CreditInvestigation'>
    <div className='cg'>
      <img src={success} alt=""></img>
      <div>签署成功，请返回继续进行资料的填写！</div>
    </div>
  </div>
}
const Fail = ({ msg, onChange }: { msg: string, onChange: () => void }) => {
  useEffect(() => {
    document.title = "签署失败"
  }, [])

  return <div className='CreditInvestigation'>
    <div className='cg'>
      <img src={fail} alt=""></img>
      <div>{msg}</div>
    </div>
    <div className='button-them' onClick={() => { onChange() }}>重新签署</div>
  </div>
}
const Agreement = ({ data }: { data: any }) => {
  const [fruits, setFruits] = useState('fruits')
  const sign = () => {
    Toast.show({
      icon: 'loading',
      content: '加载中…',
      duration: 0,
      maskClickable: false
    })
    startH5Face({ backUrl: `${location.href.split('?')[0]}?id=${encodeURIComponent(getQueryParams()['id'] as string)}`, loanid: getQueryParams()['id'] }).then(res => {
      Toast.clear()
      location.href = JSON.parse(res.data).startFaceUrl
    }).catch(err => {
      console.log(err)
    })
  }

  return <div className='CreditInvestigation Agreement'>
    <Tabs activeKey={fruits} onChange={setFruits}>
      <Tabs.Tab title='个人征信授权书' key='fruits'>
      </Tabs.Tab>
      <Tabs.Tab title='委托担保申请书' key='vegetables'></Tabs.Tab>
    </Tabs>
    {fruits == 'fruits' ?  <CustomScroll key={1}>
    <h2>个人征信授权书</h2>
      <p className='texindent'><strong>重要提示：</strong></p>
      <p className='texindent'><strong>尊敬的客户：为了维护您的权益，请在签署本授权书前，仔细阅读本授权书各条款（特别是黑体加粗字体条款），关注您在授权书中的权利、义务。</strong></p>
      <p className='texindent'><strong>除非您已阅读并接受本授权书所有条款，否则您无权使用本次服务。您的使用、登录等行为即视为您已阅读并同意本授权书条款的约束。</strong></p>
      <p className='texindent'><strong>深圳市华融融资担保有限公司：</strong></p>
      <p className='texindent'><strong>一、本人不可撤销地授权贵司在向本人提供金融产品及服务以及与贵司开展担保业务或其他业务过程中，有权按照相关法律、法规和监管要求规定，查询、使用、打印、报送本人和本人配偶的信息，具体约定如下：</strong></p>
      <p className='texindent'>本人同意并授权贵司以合法手段自行或向中国人民银行金融信用信息基础数据库或其他相关机构（包括但不限于金融机构、税务、工商、征信机构及其他监管部门、行业自律机构及贵司及/或合作平台等）采集、处理、查询、获取、验证、加工本人的基本信息（包括但不限于本人姓名、证件类型、证件号码、通讯录联系方式、财产状况、借款和还款信息、逾期信息、职业和居住地址等）。</p>
      <p className='texindent'>个人征信相关信息及其他反映本人信用状况的信息（包括但不限于不良信用记录、社会保险及公积金信息，以及视情况查询本人的收入、存款、有价证券、商业保险、不动产的信息、以虚假身份申请借款（如有）、提供虚假申请资料等欺诈信息（如有）等全部信息），并授权贵公司向上述机构及/或贵公司、贵公司的合作平台或合作机构披露或报送、留存、加工、查询、验证上述信息；</p>
      <p className='texindent'>授权贵公司及合作平台有权基于为本人提供相应的金融服务之目的，与贵公司及合作平台或合作机构共享本人的上述信息。授权贵公司及合作平台有权向本人收集相关主体信息（包括但不限于本人的人像照片及其身份信息），并将上述信息提供给贵公司及合作平台、合作机构，并由合作机构对上述信息进行核查、验证、比对识别并向贵公司输出、展示验证结果。</p>
      <p className='texindent'><strong>贵公司已明确告知本人上述信息的提供可能会对本人产生不利后果（包括但不限于：对本人的信用评级、信用报告等结果可能产生不利影响，上述信息被信息使用者依法提供给合作平台、合作机构后被他人不当利用的风险等），本人准确、完整了解前述授权的含义，确认对贵公司及合作平台、合作机构作出前述授权。</strong></p>
      <p className='texindent'><strong>本人授权贵公司及合作平台向依法成立的征信机构提供因在提供上述服务过程中产生的不良信息，且不再另行告知本人。</strong></p>
      <p className='texindent'><strong>如本人在人行征信系统中存在曾用名记录时，授权贵公司以曾用名信息进行查询，无须再作通知。</strong></p>
      <p className='texindent'><strong>二、若本人申请的上述业务未获贵司及/或合作平台等批准办理，则本授权书及形成的本人信用报告等资料均无须退回本人，但贵司应按照相关法律法规、规范性文件以及贵司相关制度的规定妥善保管或销毁。</strong></p>
      <p className='texindent'><strong>三、本授权书内容与相关业务的合同条款不一致的，无论相关合同在本授权书之前或之后签署，均应以本授权书的内容为准，但相关合同条款明确约定是针对本授权书内容所做修订的除外。</strong></p>
      <p className='texindent'><strong>四、贵司超出上述授权查询、使用、报送本人信息的一切后果和法律责任由贵司承担。</strong></p>
      <p className='texindent'><strong>五、本授权书自出具之日起生效，在本人接受贵司提供金融产品及服务以及与贵司开展担保业务或其他业务期间持续有效，非经贵司书面同意本授权书不可撤销。</strong></p>
      <p className='texindent'><strong><ins>本人声明：本授权书是本人向深圳市华融融资担保有限公司做出的单方承诺，效力具有独立性，不因任何协议、条款无效而失效。贵司已经依法向本人提示了相关条款，贵司已应本人的要求对上述条款作出相应的说明。本人已经完全知悉并充分理解本授权书条款的内容及相应的法律后果，并愿意接受本授权书条款的约定。</ins></strong></p>
      <p className='texindent'><strong>若本人与被授权人发生任何纠纷或争议，首先应友好协商解决；协商不成的，本人同意将纠纷或争议提交本授权书签订地有管辖权的人民法院管辖。本授权书的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律（不包括冲突法）。</strong></p>
      <p className='texindent'><strong><ins>本人已知悉本授权书所有内容（特别是黑体加粗字体条款）的意义以及由此产生的法律效力，自愿作出上述授权，本授权协议书是本人真实的意思表示，本人同意承担由此带来的一切法律后果。</ins></strong></p>
      <div className='zw'></div>
    </CustomScroll> : <CustomScroll key={2}>
    <h2>委托担保申请书</h2>
      <p>深圳市华融融资担保有限公司：</p>
      <p className='texindent'>兹有本人<ins>{data?.fullName}</ins> 即担保申请人（身份证号码：<ins>{data?.identityCard}</ins>）拟通过向具备贷款资质的贷款人申请贷款，具体贷款金额以贷款人实际贷款金额为准，特此向贵司申请为上述贷款提供委托担保服务。本人已仔细阅读本委托担保申请书中的所有条款，并已特别注意字体加黑的意义以及由此产生的法律效力,自愿作出上述委托担保申请，本人对所有条款的含义及相应的法律后果已全部通晓并充分理解,自愿作出上述申请、承诺和声明，同意承担由此带来的一切法律后果,同意受此约束。</p>
      <p className='texindent'><strong>一、本人承诺担保申请是本人真实自愿之意思表示，已确认并知悉申请事项及内容。</strong></p>
      <p className='texindent'><strong>二、本人知悉贵司有权基于贵司内部风控合规制度及本人信用信息情况作出接受委托提供担保或拒绝接受委托担保的决定，本人承诺尊重贵司决定。若贵司同意提供担保服务，本人知悉并同意与贵司签署《委托担保合同》，具体以实际签署的合同为准。</strong></p>
      <p className='texindent'>三、为便于贵司了解本人信用状况，作出是否提供担保之决定，<strong>本人承诺向贵司出具《个人征信查询授权书》，授权贵司按照国家相关规定采集并向金融信用信息基础数据库及其他依法成立的征信机构提供本人个人信息和包括信贷信息在内的信用信息</strong>（包含本人因未及时履行合同义务产生的不良信息）。其余授权以本人向贵司出具的《个人征信查询授权书》内容为准。</p>
      <p className='texindent'><strong>四、本人授权并委托贵司将根据委托担保申请书取得的本人的信用信息提供给贷款人及服务方，以用于本人的贷款及服务资格审核，贵司向贷款人及服务方提供本人信用信息的行为视为本人向其提供该等信息。</strong></p>
      <p className='texindent'><strong>五、本人知悉并同意承担因向贷款人及服务方提供本人信用信息而可能产生的不利后果，且自愿承担。</strong></p>
      <p className='texindent'><strong>六、如贷款人及/或服务方超出授权范围或以其他非法方式使用本人信用信息，由贷款人及/或服务方承担相关法律责任,与贵司无关。</strong></p>
      <p className='texindent'><strong>七、本申请书自本人签字、采用电子签名方式签署或以其他方式确认之日起即生效，有效期至本人债务结清且贵司担保责任解除之日止。</strong></p>
      <div className='zw'></div>
    </CustomScroll>}
    {data?.fullName&&<div className='button-them' onClick={() => { sign() }}>签署合同</div>}
  </div>
}

export default () => {
  const [status, setStatus] = useState<0 | 1 | 2 | 3>(0)
  const [nodeNel, setNodeNel] = useState<any>(null)
  const [data, setData] = useState<any>({})
  const [failData, setDailData] = useState<string>('')
  useEffect(() => {
    const urlData = getQueryParams()
    if (urlData['data']) {
      try {
        const data = JSON.parse(urlData['data'])
        // 如果电子签章返回的数据正确则去签章
        if (data.code == 0) {
          applySign({ loanid: urlData['id'] }).then(() => {
            setStatus(2)
          }).catch(() => {
            getData()
          })
        } else {
          setStatus(3)
          setDailData(data.msg)
        }
      } catch (error) {
        console.log(error)
        getData()
      }
    } else {
      getData()
    }
  }, [])
  const getData = () => {
    if (!getQueryParams()['id']) {
      setStatus(1)
      return
    }
    status === 3 && Toast.show({
      icon: 'loading',
      content: '加载中…',
      duration: 0,
      maskClickable: false
    })
    getUserInfo({ loanid: getQueryParams()['id'] }).then(res => {
      setData(res.data)
      setStatus(1)
      Toast.clear()
    }).catch(err => {
      console.log(err)
    })
  }
  useEffect(() => {
    if (status === 0) {
      setNodeNel(<ErrorBlock style={{ '--image-height-full-page': '100px' }} fullPage description={<DotLoading color='primary' />} title="" status='busy' />)
    } else if (status === 1) {
      setNodeNel(<Agreement data={data}></Agreement>)
    } else if (status === 2) {
      setNodeNel(<Success></Success>)
    } else if (status === 3) {
      setNodeNel(<Fail onChange={() => { getData() }} msg={failData}></Fail>)
    }
  }, [status])
  return nodeNel
}